// 4方向定数：プレイヤー・敵の向きと、それに対応するベクトル
export type Dir4 = 'down' | 'left' | 'right' | 'up';

export const DIR_VECTORS: Record<Dir4, { x: number; y: number }> = {
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
  right: { x: 1, y: 0 },
  up: { x: 0, y: -1 },
};

// 速度ベクトルから向きを決定（最も大きい絶対値の軸を採用）
export function vectorToDir(vx: number, vy: number, current: Dir4): Dir4 {
  if (Math.abs(vx) < 0.01 && Math.abs(vy) < 0.01) return current;
  if (Math.abs(vx) > Math.abs(vy)) return vx > 0 ? 'right' : 'left';
  return vy > 0 ? 'down' : 'up';
}

// 4方向歩行スプライトシートでの行インデックス
// 行0=down, 1=left, 2=right, 3=up（プロンプトと一致させる）
export const DIR_ROW: Record<Dir4, number> = {
  down: 0,
  left: 1,
  right: 2,
  up: 3,
};
